import { render, staticRenderFns } from "./WhyChooseUs.vue?vue&type=template&id=cd932d50&"
import script from "./WhyChooseUs.vue?vue&type=script&lang=js&"
export * from "./WhyChooseUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports